export enum SortCriteriaEnum {
  New = 'new',
  Popularity = 'popularity',
  PriceAscending = 'priceAscending',
  PriceDescending = 'priceDescending',
  CustomerRating = 'customerRating',
}
